import { LinkButton } from '@timelyapp/react';
import appleLogo from 'images/apple.svg';
import googleLogo from 'images/apps_logo/google.svg';
import React from 'react';
import styles from './AuthPage.module.scss';

interface SsoButtonsProps {
  action: 'Sign up' | 'Log in';
  testIdPrefix: 'signup' | 'signin';
}

const SsoButtons: React.FC<SsoButtonsProps> = ({ action, testIdPrefix }) => (
  <ul className={styles.options}>
    {window.BOOTSTRAPPED_DATA.google_sso_url && (
      <li>
        <LinkButton
          priority="low"
          size="large"
          linkTo={window.BOOTSTRAPPED_DATA.google_sso_url}
          className={styles.ssoButton}
          id="google-login-link"
          data-testid={`google_${testIdPrefix}_button`}
        >
          <img src={googleLogo} width={36} height={40} alt="Google logo" role="presentation" />
          {action} with Google
        </LinkButton>
      </li>
    )}
    {window.BOOTSTRAPPED_DATA.apple_sso_url && (
      <li>
        <LinkButton
          priority="low"
          size="large"
          linkTo={window.BOOTSTRAPPED_DATA.apple_sso_url}
          className={styles.ssoButton}
          id="apple-login-link"
          data-testid={`apple_${testIdPrefix}_button`}
        >
          <img
            src={appleLogo}
            width={15}
            height={19}
            className={styles.appleLogo}
            alt="Apple logo"
            role="presentation"
          />
          {action} with Apple
        </LinkButton>
      </li>
    )}
  </ul>
);

export default SsoButtons;
